// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___3u15W","inner":"styles-module__inner___3VIGS","checkbox":"styles-module__checkbox___30fxW","label":"styles-module__label___WgYla"};